import * as React from "react";
const SvgFiRrPumpkinAlt2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pumpkin-alt-2_svg__a)">
      <path
        fill="#062147"
        d="M17.238 6c-.909 0-1.746.333-2.427.965a5.4 5.4 0 0 0-1.779-.807C13.349 2.052 15.972 2 16 2c.551 0 1 .448 1.001 1A1 1 0 0 0 17 5c1.103 0 2-.897 2-2 0-1.654-1.346-3-3-3-1.121 0-2.884.623-3.99 2.562A5.87 5.87 0 0 0 9.447.105a1 1 0 0 0-.895 1.789c1.462.731 2.253 2.133 2.413 4.264a5.4 5.4 0 0 0-1.777.806 3.5 3.5 0 0 0-2.427-.965C3.635 6 0 9.932 0 15s3.635 9 6.762 9c.909 0 1.746-.332 2.428-.965 1.84 1.264 3.781 1.264 5.621 0a3.51 3.51 0 0 0 2.428.965c3.127 0 6.762-3.932 6.762-9s-3.636-9-6.763-9m0 16c-.419 0-.764-.142-1.082-.444a1.94 1.94 0 0 0-1.345-.552c-.376 0-.753.114-1.082.346-1.205.852-2.255.852-3.461 0-.749-.527-1.747-.442-2.425.205-.319.304-.663.445-1.083.445-1.873 0-4.762-3.006-4.762-7S4.887 8 6.76 8c.418 0 .761.141 1.08.443.682.648 1.681.731 2.431.204 1.203-.848 2.252-.848 3.455 0 .749.527 1.748.444 2.431-.204.318-.303.661-.443 1.08-.443 1.873 0 4.762 3.006 4.762 7s-2.889 7-4.762 7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pumpkin-alt-2_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPumpkinAlt2;
